import GiftDetailsForm from "./giftDetailsForm.container";

export default GiftDetailsForm;
